import { render, staticRenderFns } from "./DiscountReason.vue?vue&type=template&id=230ce70c&scoped=true"
import script from "./DiscountReason.vue?vue&type=script&lang=js"
export * from "./DiscountReason.vue?vue&type=script&lang=js"
import style0 from "./DiscountReason.vue?vue&type=style&index=0&id=230ce70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230ce70c",
  null
  
)

export default component.exports